import type { FetchDailyArgs } from '../../../api/types/stats.types';

import { queryKeys } from '../../../queryKeys';
import { useQuery } from '../../base';

export function useDaily({
  enabled = true,
  ...args
}: { enabled?: boolean } & FetchDailyArgs = {}) {
  const { queryFn, queryKey } = queryKeys.statsMeasurements.fetchDaily(args);
  return useQuery({
    enabled,
    queryFn,
    queryKey,
  });
}
